import create from 'zustand';
import { NotificationRecipientDTO } from '../../api-client/generated';

interface NotificationsState {
  decrementUnreadCount: () => void;
  incrementUnreadCount: () => void;
  markAllNotificationsAsDismissed: () => void;
  markAllNotificationsAsRead: () => void;
  notifications: NotificationRecipientDTO[];
  resetUnreadCount: () => void;
  setNotifications: (notifications: NotificationRecipientDTO[]) => void;
  setUnreadCount: (count: number) => void;
  unreadCount: number;
  updateNotification: (
    id: string,
    status: 'read' | 'sent' | 'dismissed'
  ) => void;
}

const useNotificationFeedStore = create<NotificationsState>((set) => ({
  decrementUnreadCount: () =>
    set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) })),
  incrementUnreadCount: () =>
    set((state) => ({ unreadCount: state.unreadCount + 1 })),
  markAllNotificationsAsDismissed: () =>
    set((state) => ({
      notifications: state.notifications.map((notification) => ({
        ...notification,
        status: 'dismissed'
      }))
    })),
  markAllNotificationsAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((notification) => ({
        ...notification,
        status: notification.status === 'sent' ? 'read' : notification.status
      }))
    })),
  notifications: [],
  resetUnreadCount: () => set({ unreadCount: 0 }),
  setNotifications: (notifications) => {
    set({ notifications });
    // set({
    //   unreadCount: notifications.filter((n) => n.status === 'sent').length
    // });
  },
  setUnreadCount: (count) => set({ unreadCount: count }),
  unreadCount: 0,
  updateNotification: (id, status) =>
    set((state) => ({
      notifications: state.notifications.map((notification) =>
        notification.id === id ? { ...notification, status } : notification
      )
    }))
}));

export default useNotificationFeedStore;
